export default "__VITE_ASSET__BBGdttwE__"